import React, { useState, setState, useEffect, createContext, useContext, useCallback, useMemo, useRef } from 'react';
import Accordion, { Item } from 'devextreme-react/accordion';
import CheckBox from 'devextreme-react/check-box';
import TagBox from 'devextreme-react/tag-box';
import Slider, { Tooltip, Label } from 'devextreme-react/slider';
import axios from 'axios';
import appInfo from '../../app-info';
import DataSource from 'devextreme/data/data_source';

import circleRed from '../../Images/red-circle.png';
import circleGreen from '../../Images/green-circle.png';
import circleYellow from '../../Images/yellow-circle.png';

import './accordion.scss'

// import service from './data.js';
// import CustomTitle from './CustomTitle.js';

const companyLabel = { 'aria-label': 'Company' };

function myCast_ToString(str) {
    if (str) {
        return str;
    } else {
        return '';
    }

}

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedItems: 0,
            multiple: false,
            collapsible: false,
            animationDuration: 300,
            ruoli: [],
            titleGroup: []
        };
        this.selectionChanged = this.selectionChanged.bind(this);
        this.selectedItemsChanged = this.selectedItemsChanged.bind(this)
    }

    async UNSAFE_componentWillMount() {
        const url = appInfo.urlWebApi;
        const user = this.props.user;

        var result = [];

        console.log('DataSourceRiepilogo2');
        const queryParameters = new URLSearchParams(window.location.search);
        const prev = queryParameters.get("d");
        console.log(queryParameters);
        console.log(prev);
        var result;
        console.log(user);
        if (user) {

            const instance = axios.create({
                baseURL: url,
                timeout: 3000,
                headers: { 'X-Custom-Header': 'foobar' }
            });
            await instance.get('/api/FlussiApprovativi/GetDatiRiepilogoContratto', {
                params: { internalKey: user.internalKey, idPreventivo: prev }
            })
                .then(function (response) {
                    console.log('response')
                    console.log(response.data);
                    result = response.data;
                })
                .catch(function () {
                })
                .finally(function () { });

            this.setState({ ruoli: result });

            var tempValue = [];
            result.forEach(function (a) {
                if (tempValue.indexOf(a.GRUPPO) == -1) tempValue.push(a.GRUPPO);
            });

            this.setState({ titleGroup: tempValue })

        }
    }

    render() {
        const {
            selectedItems, multiple, collapsible, animationDuration, ruoli, titleGroup
        } = this.state;

        const dataSource = new DataSource({
            store: titleGroup,
            refreshMode: 'reshape'
        })

        function valueByTypeCalcolato(item) {
            var tipo = item.TIPO_CAMPO;
            var valore = myCast_ToString(item.VALORE_CALCOLATO);

            if (tipo == 'VALUTA' || tipo == 'NUMERICO'){
                if (!isNaN(parseFloat(valore.replace(',', '.')))) {
                    valore = parseFloat(valore.replace(',', '.')).toLocaleString("it-IT", { maximumFractionDigits: 2 });
                }
            }
            else if (tipo == 'V0' || tipo == 'V1' || tipo == 'V2' || tipo == 'V3' || tipo == 'V4' || tipo == 'V5' || tipo == 'V6' || tipo == 'V7' || tipo == 'V8' || tipo == 'V9') {                
                if (!isNaN(parseFloat(valore.replace(',', '.')))) {  
                    valore = parseFloat(valore.replace(',', '.')).toLocaleString("it-IT", { minimumFractionDigits: parseInt(tipo.replace('V', '')) });
                }
            }
            else if (tipo == 'YN')
                valore = valore == '0' ? 'No' : 'Sì';

            return valore;
        }


        function itemTitleRender(data) {
            var checkLimitiN = 0;
            var checkLimitiX = 0;
            ruoli.filter(x => x.GRUPPO == data).map(function (item) {
                if (myCast_ToString(item.LIMITI) == 'N') checkLimitiN++
                if (myCast_ToString(item.LIMITI) == 'X') checkLimitiX++
            });            
            return (
                <h1>
                    <b className={checkLimitiN > 0 ? 'redrow' : (checkLimitiX > 0 ? 'yellowrow' : ( data.endsWith("(Vuoto)") ? 'grayrow' : 'blackrow')) }>{data}</b>
                </h1>
            );
        }

        function itemRender(data) {
            return ruoli.filter(x => x.GRUPPO == data).map(function (item) {
                return (
                    <tr>
                        <td width={30}>
                            <img width='14px' height='14px' src={(myCast_ToString(item.LIMITI) == 'Y') ? circleGreen : ((myCast_ToString(item.LIMITI) == 'N') ? circleRed : ((myCast_ToString(item.LIMITI) == 'X') ? circleYellow : ''))}></img>
                        </td>
                        <td>
                            <b>{item.DESCRIZIONE} </b><br />
                            <span className='spanStyle'>{valueByTypeCalcolato(item) + ' ' + myCast_ToString(item.UDM)}</span><br />

                        </td>
                    </tr>
                )
            });
        }

        function onItemTitleClick(e) {
            console.log('onItemTitleClick');
              console.log(e);
                if(e.itemData.endsWith("(Vuoto)")) { e.event.stopPropagation(); }
              
            }
        

        return (
            <div id="accordion">
                <Accordion
                    collapsible={this.props.collapsible}
                    multiple={false}
                    dataSource={dataSource}
                    itemTitleRender={itemTitleRender}
                    itemRender={itemRender}
                    onItemTitleClick={onItemTitleClick}
                    animationDuration={animationDuration}
                // selectedIndex={this.props.selectedIndex}         
                // onSelectionChanged={this.selectionChanged}
                />

            </div>
        );
    }


    selectionChanged(e) {
        let newItems = [...this.state.selectedItems];
        e.removedItems.forEach((item) => {
            const index = newItems.indexOf(item);
            if (index >= 0) {
                newItems.splice(index, 1);
            }
        });
        if (e.addedItems.length) {
            newItems = [...newItems, ...e.addedItems];
        }
        this.setState({
            selectedItems: newItems,
        });
    }

    selectedItemsChanged(e) {
        this.setState({
            selectedItems: e.value,
        });
    }

 
}

export default App;
